// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect } from "react";

const getPreviewData = async (query, variables, token) => {
  const url = token
    ? `${process.env.GATSBY_CRAFT_API_URL}?token=${token}`
    : process.env.GATSBY_CRAFT_API_URL;

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${process.env.GATSBY_CRAFT_API_TOKEN}`,
  };

  const body = JSON.stringify({
    query,
    variables: {
      ...variables,
      uri: variables.uri.replace(/\/$/, ""),
      site: process.env.GATSBY_CRAFT_SITE_HANDLE,
    },
  });

  const { data: previewData } = await fetch(url, {
    method: "post",
    headers,
    body,
  })
    .then(res => res.json())
    .then(res => {
      if (!res.errors) {
        return res;
      }
      throw Error(JSON.stringify(res.errors));
    })
    .catch(e => {
      // eslint-disable-next-line no-console
      console.log(e);
    });

  return previewData;
};

const useCraftPreview = ({ data: _data, query, variables }) => {
  const [data, setData] = useState({ data: _data, isPreview: false });
  // check if it's a preview and fetch preview data if so
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const token = urlParams.get("token");
    const section = urlParams.get("section");
    const type = urlParams.get("type");
    // get live data if type & section is passed along
    const isPreview = !!token || type || section;

    if (isPreview) {
      // setData({ data: false, isPreview: true });
      getPreviewData(query, variables, token)
        .then(previewData => {
          setData({ data: previewData, isPreview: true });
        })
        .catch(e => {
          // eslint-disable-next-line no-console
          console.log(e);
        });
    }
  }, []);

  return data;
};

export default useCraftPreview;
